export enum AdminCatalogPageTabs {
    Catalogs = 'catalogs',
    Products = 'products',
}
